import { useEffect } from 'react';
import Head from 'next/head';
import { useFontOverride } from 'utils/font-override-context';
import { useFunnelData } from 'utils/funnel-data-context';

export default function DynamicHead({ metaDescription }: { metaDescription?: string }) {
  const { canonicalUrl, fontLoadQueryString } = useFunnelData();

  // https://pagespeedchecklist.com/asynchronous-google-fonts
  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'style';
    link.href = `https://fonts.googleapis.com/css2?family=${fontLoadQueryString}&display=swap`;
    link.onload = () => {
      link.rel = 'stylesheet';
    };

    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, [fontLoadQueryString]);

  return (
    <Head>
      {/* Google Fonts */}
      {metaDescription && <meta name="description" content={metaDescription}></meta>}
      {process.env.NEXT_PUBLIC_USE_SYSTEM_FONTS !== 'true' && fontLoadQueryString && (
        <noscript>
          <link
            rel="stylesheet"
            href={`https://fonts.googleapis.com/css2?family=${fontLoadQueryString}&display=swap`}
          />
        </noscript>
      )}

      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
    </Head>
  );
}

export function DynamicContentHead({
  metaDescription,
  canonicalUrl,
}: {
  metaDescription?: string;
  canonicalUrl: string;
}) {
  const { fontLoadQueryString } = useFontOverride();

  // https://pagespeedchecklist.com/asynchronous-google-fonts
  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'style';
    link.href = `https://fonts.googleapis.com/css2?family=${fontLoadQueryString}&display=swap`;
    link.onload = () => {
      link.rel = 'stylesheet';
    };

    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, [fontLoadQueryString]);

  return (
    <Head>
      {/* Google Fonts */}
      {metaDescription && <meta name="description" content={metaDescription}></meta>}
      {process.env.NEXT_PUBLIC_USE_SYSTEM_FONTS !== 'true' && fontLoadQueryString && (
        <noscript>
          <link
            rel="stylesheet"
            href={`https://fonts.googleapis.com/css2?family=${fontLoadQueryString}&display=swap`}
          />
        </noscript>
      )}

      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
    </Head>
  );
}
